import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react';
import { clerkPublishableKey, isClerkEnabled } from './utils/clerkConfig';
import { initAnalytics } from './utils/analytics';

const container = document.getElementById('root');

const appTree = (
  <React.StrictMode>
    {isClerkEnabled ? (
      <ClerkProvider publishableKey={clerkPublishableKey}>
        <App />
      </ClerkProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

if (!isClerkEnabled) {
  // eslint-disable-next-line no-console
  console.warn(
    'Clerk publishable key not found. Set REACT_APP_CLERK_PUBLISHABLE_KEY (or NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY) to enable auth.'
  );
}

const hasPrerenderSnapshot = Boolean(
  container.querySelector('#prerender-snapshot-marker')
);

if (hasPrerenderSnapshot) {
  container.innerHTML = '';
}

const root = ReactDOM.createRoot(container);
root.render(appTree);

initAnalytics();

// Prevent pinch-to-zoom gestures on mobile WebKit/Safari
if (typeof document !== 'undefined') {
  document.addEventListener('gesturestart', (e) => {
    e.preventDefault();
  });
  document.addEventListener('gesturechange', (e) => {
    e.preventDefault();
  });
  document.addEventListener('gestureend', (e) => {
    e.preventDefault();
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
